import { getServerApi } from '@/gql';
import { Memory } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseMemoriesResult {
    memories: Memory[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Memory[]>;
}

export const useMemories = (tokenId: number): UseMemoriesResult => {
    const [memories, setMemories] = useState<Memory[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getMemories = async () => {
        if (!tokenId || !userId) {
            setMemories([]);
            return [];
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.memories({
                tokenId: tokenId,
                pageNum: 1,
                pageSize: 20,
            });
            if (response?.memories !== undefined) {
                setMemories(response.memories);
                return response.memories;
            } else {
                setMemories([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch memories:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch memories'),
            );
            setMemories([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getMemories();
    }, [tokenId, userId]);

    return {
        memories,
        loading,
        error,
        refetch: getMemories,
    };
};
